import {
  MERGE_ALERTS_TO_CASE,
  MERGE_ALERTS_TO_CASE_SUCCESS,
  MERGE_ALERTS_TO_CASE_FAIL,
  CLOSE_MERGE_ALERTS_TO_CASE_MODAL
} from '../../actions/cm/mergeAlertsToCase';

export const initialState = {
  isLoading: false,
  isMergeAlertToCaseFailed: false,
  showMergeInfoModal: false,
  message: '',
  assignedDepartmentId: null,
  // FIN-12898 — partial-merge outcome of the last successful merge
  merged: [],
  skippedAlreadyCased: [],
  // FIN-13021 — ids that resolve to no alert row
  skippedUnknown: []
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case MERGE_ALERTS_TO_CASE:
      return {
        ...state,
        isMergeAlertToCaseFailed: false,
        showMergeInfoModal: false,
        isLoading: true
      };
    case MERGE_ALERTS_TO_CASE_SUCCESS:
      return {
        ...state,
        showMergeInfoModal: true,
        isLoading: false,
        assignedDepartmentId: payload.assignedDepartmentId,
        merged: payload.merged || [],
        skippedAlreadyCased: payload.skippedAlreadyCased || [],
        skippedUnknown: payload.skippedUnknown || []
      };
    case MERGE_ALERTS_TO_CASE_FAIL:
      return {
        ...state,
        isMergeAlertToCaseFailed: true,
        isLoading: false,
        message: payload.message
      };
    case CLOSE_MERGE_ALERTS_TO_CASE_MODAL:
      return {
        ...state,
        showMergeInfoModal: false,
        isMergeAlertToCaseFailed: false,
        isLoading: false
      };
    default:
      return state;
  }
}
